import { render, staticRenderFns } from "./NegotiatedPrice.vue?vue&type=template&id=515b4ed2&scoped=true&"
import script from "./NegotiatedPrice.vue?vue&type=script&lang=ts&"
export * from "./NegotiatedPrice.vue?vue&type=script&lang=ts&"
import style0 from "./NegotiatedPrice.vue?vue&type=style&index=0&id=515b4ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515b4ed2",
  null
  
)

export default component.exports